
<template>
  <!--添加位置-->
  <div>
    <x-addEdit
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'addLocation',
  data () {
    let decoratorOptions = {
      community_id: {
        rules: [{ required: true, message: '请选择小区' }]
      },
      building_id: {
        rules: [{ required: false, message: '请选择楼栋' }]
      },
      position_name: {
        rules: [
          {required: true, message: '请输入位置名称'},
          { pattern: this.REG.name, message: '位置名称为2-20位汉字、字母、数字' }
        ]
      },
      category_id: {
        rules: [{required: true, message: '请选择所属分类'}]
      },
      is_strictly: { rules: [] }
    };
    return {
      formList: [
        {
          label: '所属小区',
          inputType: 'select',
          options: [],
          handle: (e) => {
            this.communityChange(1, e, 'formList');
            this.$children[0].resetSubValue(['building_id', 'unit_id'], e);
          },
          placeholder: '请选择小区',
          props: ['community_id', decoratorOptions.community_id]
        },
        {
          label: '所属楼栋',
          inputType: 'select',
          options: [],
          handle: (e) => {
            this.buildingChange(2, e, 'formList');
            this.selectedBuilding(e);
          },
          placeholder: '请选择楼栋',
          props: ['building_id', decoratorOptions.building_id]
        },
        {
          label: '所属单元',
          inputType: 'select',
          options: [],
          placeholder: '请选择单元',
          props: ['unit_id',
            { rules: [{ required: false, message: '请选择单元' }] }
          ]
        },
        {
          label: '位置名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入位置名称',
          props: ['position_name', decoratorOptions.position_name]
        },
        {
          label: '所属分类',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择所属分类',
          fieldNames: {label: 'title', value: 'category_id', children: 'children'},
          props: ['category_id', decoratorOptions.category_id]
        },
        {
          label: '是否受限',
          inputType: 'checkboxGroup',
          options: [{ label: '', value: 1 }],
          placeholder: '',
          props: ['is_strictly', decoratorOptions.is_strictly]
        }
      ],
      formKey: {
        community_id: '',
        building_id: '',
        unit_id: '',
        position_name: '',
        category_id: '',
        is_strictly: ''
      },
      addParam: {
        url: '/position/add',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/position/edit/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/position/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    this.setDisable();
    this.communitySelect(0, 'formList', 1);
    this.deviceManageSelect([{ index: 4, scope: 'formList', key: 'category' }], {category_module: 'position'});
  },
  methods: {
    setDisable () {
      if (this.$route.query.can_delete === '0') {
        let propArr = ['community_id', 'building_id', 'unit_id'];
        this.formList.forEach((item) => {
          let hasProp = propArr.some(el => el === item.props[0]);
          if (hasProp) {
            item.disabled = true;
          }
        });
      }
    },
    /* 选择所属楼栋 */
    selectedBuilding (e) {
      this.formList.forEach((el) => {
        let props = el.props;
        if (props && props[0] === 'unit_id') {
          let unitId = props[1].rules[0];
          e ? unitId.required = true : unitId.required = false;
          this.$children[0].resetSubValue(['unit_id'], e);
        }
      });
    },
    detailResHandle (data) {
      let formValues = {};
      let keyArr = ['building_id', 'unit_id'];
      keyArr.forEach((el) => {
        if (data.hasOwnProperty(el) && data[el]) {
          formValues[el] = data[el];
        } else {
          formValues[el] = '';
        }
      });

      this.formList.forEach((el) => {
        if (el.props && el.props[0] === 'unit_id') {
          let rule = el.props[1].rules[0];
          data.building_id ? rule.required = true : rule.required = false;
        }
      });

      if (data.is_strictly) {
        formValues.is_strictly = [data.is_strictly];
      } else {
        formValues.is_strictly = [];
      }
      if (data.community_id) { // 根据小区id获取楼栋列表
        this.communityChange(1, data.community_id, 'formList');
      }
      if (data.community_id && data.building_id) { // 根据小区id楼栋id获取单元列表
        this.buildingChange(2, data.building_id, 'formList');
      }
      return formValues;
    },
    reqHandle (param) {
      console.log('处理请求前数据: ', param);
      return param;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/baseData/location/addLocation.vue